import React from 'react';

type Props = {
  title: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
};

export default function FAQItem({ title, children, icon }: Props) {
  return (
    <article className="grid gap-5 border-b border-emerald-900/10 py-8 transition-colors hover:border-[#D97706]/50 md:grid-cols-[4rem_1fr]">
      <div className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-[#0B2F2A] text-lg text-[#FCD34D]">
        {icon}
      </div>
      <div className="min-w-0">
        <div className="mb-4 hidden h-px w-full max-w-xs bg-gradient-to-r from-[#D97706]/60 to-transparent md:block" />
        <h3 className="text-xl font-semibold leading-8 tracking-tight text-[#0B2F2A]">{title}</h3>
        <p className="mt-3 max-w-3xl text-sm leading-7 text-[#56736B]">{children}</p>
      </div>
    </article>
  );
}
